import {
  ProjectDto,
  useProjectQuery
} from 'providers/api';
import React from 'react';
import { UseQueryResult } from 'react-query';
import { EditBinderCostSettingsPageParams } from './constants';

export type EditBinderCostSettingsQueries = [
  UseQueryResult<ProjectDto>
];

const useEditBinderCostSettingsQueries = (params: EditBinderCostSettingsPageParams): EditBinderCostSettingsQueries => {
  const [project, setProject] = React.useState<ProjectDto | null>(null);

  const query = useProjectQuery(
    params.projectId as string,
    {
      enabled: !project,
      cacheTime: 0,
    },
  );

  const { data, isFetched } = query;

  React.useEffect(() => {
    if (data && isFetched && !project) {
      setProject(data);
    }
  }, [data, project, isFetched]);

  return [query];
};

export default useEditBinderCostSettingsQueries;
